import { Box, Typography, styled } from "@mui/material";

export const AssistantWelcome = styled(Box)(({ theme }) => ({
  marginTop: "auto",
  marginBottom: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.spacing(4),
  "& > svg": {
    color: theme.palette.primary.main,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

export const AssistantQuestion = styled(Typography)(({ theme }) => ({
  alignSelf: "flex-end",
  maxWidth: "92%",
  display: "block",
  whiteSpace: "pre-wrap",
  padding: theme.spacing(3, 4),
  borderRadius: theme.shape.borderRadius[2],
  backgroundColor: theme.palette.custom.semantic.surface.hover,
}));

export const AssistantPendingResponse = styled(Box)({
  position: "relative",
  minHeight: 48,
});
